<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Documentación del proceso</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <div class="row">
        <div
          class="col-12"
          v-if="
            !info.requestSigned &&
            !info.receiptReturnReport &&
            !info.subscribedAccreditationResolution &&
            !info.certificateAccreditationSymbol &&
            !info.accreditationSymbol
          "
        >
          <div class="card card-with-search border-0 card-with-shadow">
            <div class="card-body">
              <app-empty-data-block
                message="Ningún documento encontrado para esta acreditación"
              />
            </div>
          </div>
        </div>
        <div
          class="col-12"
          v-if="
            info.requestSigned ||
            info.receiptReturnReport ||
            info.subscribedAccreditationResolution ||
            info.certificateAccreditationSymbol ||
            info.evaluations ||
            info.accreditationSymbol
          "
        >
          <legend>
            <small
              ><p class="text-primary">
                Comprobante de pago de la licencia
              </p></small
            >
          </legend>

          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th
                  scope="col"
                  class="align-middle text-center"
                  style="width: 10%"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="inputs.license_payment_file">
                <td class="align-middle">
                  {{ inputs.license_payment_file.user.full_name }}
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(inputs.license_payment_file.path)"
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <legend>
            <small
              ><p class="text-primary">Documentos de la acreditación</p></small
            >
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th
                  scope="col"
                  class="align-middle text-center"
                  style="width: 10%"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.requestSigned">
                <td class="align-middle">Solicitud de Acreditación</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(info.requestSigned.path)"
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
              <tr v-if="info.receiptReturnReport">
                <td class="align-middle">
                  Registro de Ingreso de solicitud de acreditación y acuse
                  recibo
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(info.receiptReturnReport.path)"
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>

              <tr v-if="info.evaluations && info.evaluations.length > 0">
                <td class="align-middle">Propuesta del Equipo Evaluador</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(info.evaluations[0].file_evaluation.path)"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>

              <tr v-if="info.subscribedAccreditationResolution">
                <td class="align-middle">Resolución suscrita</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(info.subscribedAccreditationResolution.path)
                    "
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
              <tr v-if="info.certificateAccreditationSymbol">
                <td class="align-middle">Certificado de Acreditación</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(info.certificateAccreditationSymbol.path)
                    "
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
              <tr v-if="info.accreditationSymbol">
                <td class="align-middle">Símbolo de Acreditación</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(info.accreditationSymbol.path)"
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- <div class="col-12" v-if="info.deposits && info.deposits.length > 0"> -->
            <legend class="col-12 col-form-label text-primary pt-0 my-3" v-if="info.deposits && info.deposits.length > 0">
              <h5>FACTURAS EMITIDAS</h5>
            </legend>
            <table class="table table-sm table-striped" v-if="info.deposits && info.deposits.length > 0">
              <thead>
                <tr>
                  <th scope="col" class="align-middle">NOMBRE</th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 25%"
                  >
                    USUARIO
                  </th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 15%"
                  >
                    FECHA
                  </th>
                  <th
                    scope="col"
                    class="align-middle text-center"
                    style="width: 10%"
                  ></th>
                </tr>
              </thead>
              <tbody v-for="(v, i) in info.deposits" :key="i">
                <tr v-for="(u, j) in v.invoices" :key="j">
                  <!-- <div style="width:100%" > -->
                  <td class="align-middle">{{ u.filename }}</td>
                  <td class="align-middle text-center">
                    <span v-if="u.annexed">
                      {{
                        `${u.annexed.user.first_name} ${u.annexed.user.last_name}`
                      }}
                    </span>
                  </td>
                  <td class="align-middle text-center">
                    <span v-if="u.file">
                      {{ u.file.created_at | dateFormat }}
                    </span>
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(u.annexed.path)"
                      v-if="u.annexed"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                  <!-- </div> -->
                </tr>
              </tbody>
            </table>
          <!-- </div> -->
          
          <legend>
            <small
              ><p class="text-primary">
                Documentos de Evaluaciones/Testificaciones
              </p></small
            >
          </legend>
          <table
            class="table table-sm table-striped"
            v-for="(value, key) in info.evaluations"
            :key="key"
          >
            <thead>
              <tr>
                <legend>
                  <small class="text-primary">
                    {{ value.code }}
                  </small>
                </legend>
              </tr>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th
                  scope="col"
                  class="align-middle text-center"
                  style="width: 10%"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="value.proforma">
                <td class="align-middle">Proforma</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(value.proforma.path)"
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>

              <tr v-if="value.deposits">
                <td class="align-middle">Comprobante de pago de la proforma</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(value.deposits.file.path)"
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
              <tr v-for="(item, c) in value.eval_annexes_files" :key="c + 1">
                <td class="align-middle">Personal externo</td>
                <td class="align-middle text-center">
                  <a
                    :href="item.annexed.full_url"
                    class="btn btn-success"
                    target="_blank"
                  >
                    <app-icon name="file"></app-icon> Ver
                  </a>
                </td>
              </tr>
              <tr v-for="ext in value.evaluation_team" :key="ext.id">
                <td class="align-middle" v-if="ext.evaluation_team_external">Personal externo</td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTabExt(ext,'evaluation_team_external')
                    "
                  >
                    <app-icon name="file" />
                  </button>
                </td> 
              </tr>
              <tr v-for="(v, i) in value.deposits?.invoices" :key="i">
                <td class="align-middle">Factura emitida</td>
                <td class="align-middle text-center">
                  <button
                    v-if="v.annexed"
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(v.annexed.path)"
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>

              <tr v-if="value.report_documentary_evaluation">
                <td class="align-middle">Informe de evaluación Documental</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(value.report_documentary_evaluation.path)
                    "
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
              <tr v-if="value.evaluation_plan_report">
                <td class="align-middle">Plan de evaluación</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(value.evaluation_plan_report.path)"
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
              <tr v-if="value.testification_report">
                <td class="align-middle">Informe de testificación</td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(value.testification_report.path)"
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
              <tr v-if="value.remote_in_situ_assessment_report">
                <td class="align-middle">
                  Informe de evaluación In-Situ Remota
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="
                      openTab(value.remote_in_situ_assessment_report.path)
                    "
                  >
                    <app-icon name="file" />
                  </button>
                </td>
              </tr>
              <!-- <tr v-if="!value.evaluation_plan_report || !value.remote_in_situ_assessment_report">
                <td colspan="2">
                  No se ha cargado archivos
                </td>
              </tr> -->
            </tbody>
          </table>
        </div>
      </div>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
export default {
  mixins: [FormMixin, ModalMixin],
  data() {
    return {
      preloader: false,
      info: {},
      inputs: {},
      modalId: "document-modal",
    };
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {},
    afterSuccessFromGetEditData(response) {
      this.info = response.data;

      let url = `/accreditations/applications/showValidLicense/${response.data.accApp.user_id}/${response.data.accApp.accreditation_activity_id}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
      });

      this.preloader = false;
    },
    openTab(path) {
      window.open(path, "_blank").focus();
    },
    openTabExt(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
  },
};
</script>
